import { createStore } from "redux";
import cartReducer from "../Reducers";

const Store = createStore(cartReducer);

export default Store;